import React, { useState } from 'react';
import { Clock, Zap, AlertTriangle, Crown } from 'lucide-react';
import { useSubscription } from '../contexts/SubscriptionContext';
import { isIOS } from '../utils/payments';
import UpgradeModal from './UpgradeModal';
import toast from 'react-hot-toast';
import './TrialBanner.css';

export default function TrialBanner() {
  const { isPremium, isTrialing, isTrialExpired, trialDaysRemaining, restorePurchases, refreshProfile } = useSubscription();
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [restoring, setRestoring] = useState(false);

  // Don't show for premium users (active subscription, not trialing)
  if (isPremium && !isTrialing) return null;

  let urgency = 'normal';
  let message = '';
  let Icon = Clock;

  if (isTrialExpired) {
    urgency = 'expired';
    message = 'Your trial has ended. Upgrade to keep your premium features.';
    Icon = AlertTriangle;
  } else if (isTrialing && trialDaysRemaining <= 3) {
    urgency = 'urgent';
    message = `${trialDaysRemaining} day${trialDaysRemaining !== 1 ? 's' : ''} left in your trial`;
    Icon = Zap;
  } else if (isTrialing) {
    message = `${trialDaysRemaining} days left in your free trial`;
  } else {
    // Free user (no trial)
    urgency = 'free';
    message = 'Unlock unlimited projects, areas & more';
    Icon = Crown;
  }

  const handleRestore = async (e) => {
    e.stopPropagation();
    setRestoring(true);
    try {
      await restorePurchases();
      await refreshProfile();
      toast.success('Purchases restored');
    } catch (err) {
      toast.error(err.message || 'Failed to restore purchases');
    } finally {
      setRestoring(false);
    }
  };

  return (
    <>
      <div className={`trial-banner trial-banner--${urgency}`}>
        <Icon size={14} />
        <span>{message}</span>
        {isIOS() && (
          <button
            className="trial-banner-restore"
            onClick={handleRestore}
            disabled={restoring}
          >
            {restoring ? 'Restoring...' : 'Restore'}
          </button>
        )}
        <button
          className="trial-banner-cta"
          onClick={() => setShowUpgrade(true)}
        >
          Upgrade
        </button>
      </div>
      {showUpgrade && (
        <UpgradeModal onClose={() => setShowUpgrade(false)} />
      )}
    </>
  );
}
